import { render } from "./garantiaCard.vue?vue&type=template&id=304621aa&scoped=true"
import script from "./garantiaCard.vue?vue&type=script&lang=js"
export * from "./garantiaCard.vue?vue&type=script&lang=js"

import "./garantiaCard.vue?vue&type=style&index=0&id=304621aa&lang=css"
import "./garantiaCard.vue?vue&type=style&index=1&id=304621aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304621aa"]])

export default __exports__